import { Language } from '../../enums/language/language';
import { NotificationConfiguration } from './notification-configuration';
import { NotificationMetadata } from './notification-metadata';

export class Notification {
  token: string;
  title: string;
  description: string;
  read: boolean;
  createdAt: Date;
  metadata?: NotificationMetadata;
  image: string;
  language?: Language;
  config: NotificationConfiguration;
}
